module.exports = __webpack_public_path__ + "img/a.c04ce406.png";